export default { sha: 'ba5c8588c5a75c63fdeda895433055b41a69a65d', buildNumber: 'undefined' }
